import { jsx as _jsx } from "react/jsx-runtime";
import Decimal from 'decimal.js';
import { Bank, Business, Coins, Document, Edit, Invoice, User } from 'seagull/icons';
import { getURLWithFullPageInvoice } from '~/components/FullPageInvoice/FullPageInvoice.utils';
import { routes } from '~/constants';
import { timeModel } from '~/models';
import { utils } from '~/utils';
export const getNotificationPresentationData = (notificationItem)=>{
    switch(notificationItem.type){
        case 'relationship':
            {
                return getRelationshipPresentationData(notificationItem);
            }
        case 'invoice':
            {
                return getInvoicePresentationData(notificationItem);
            }
        case 'payout':
            {
                return getPayoutPresentationData(notificationItem);
            }
        case 'user':
            {
                return getUserPresentationData(notificationItem);
            }
        case 'business':
            {
                return getBusinessPresentationData(notificationItem);
            }
    }
};
const getRelationshipPresentationData = (relationshipNotificationItem)=>{
    const { type, id, customerName, clientName } = relationshipNotificationItem.relationship;
    const agreementPath = routes.agreement(id);
    const billingHubPath = routes.billingHub(id);
    switch(type){
        case 'approved':
            return {
                icon: /*#__PURE__*/ _jsx(Document, {}),
                content: "Agreement with ".concat(customerName, " was approved by ").concat(clientName),
                path: agreementPath,
                type
            };
        case 'adhocChargeApproved':
            return {
                icon: /*#__PURE__*/ _jsx(Coins, {}),
                content: "Charge to ".concat(customerName, " was approved by ").concat(clientName),
                path: billingHubPath,
                type
            };
        case 'approvedAmendments':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: "Amendment to the agreement with ".concat(customerName, " was approved by ").concat(clientName),
                path: agreementPath,
                type
            };
        case 'autoApprovedAmendments':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: "Amendment to the agreement with ".concat(customerName, " was approved by ").concat(clientName),
                path: agreementPath,
                type
            };
        case 'stoppedAutoApproval':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: "".concat(clientName, " declined the auto-approval of the latest amendments to the agreement with ").concat(customerName),
                path: agreementPath,
                type
            };
    }
};
const getInvoicePresentationData = (invoiceNotificationItem)=>{
    const { type, id, relationshipId, formattedNumber } = invoiceNotificationItem.invoice;
    const invoicesPath = getURLWithFullPageInvoice({
        relationshipId,
        invoiceId: id
    });
    switch(type){
        case 'paymentFailed':
            return {
                icon: /*#__PURE__*/ _jsx(Invoice, {}),
                content: "Payment for invoice ".concat(formattedNumber, " has failed"),
                path: invoicesPath,
                type
            };
        case 'invoiceIssuedRequiresApproval':
            return {
                icon: /*#__PURE__*/ _jsx(Invoice, {}),
                content: "Invoice ".concat(formattedNumber, " pending approval"),
                path: invoicesPath,
                type
            };
    }
};
const getPayoutPresentationData = (payoutNotificationItem)=>{
    const { type, amount, arrivalDate } = payoutNotificationItem.payout;
    const payoutPath = "".concat(routes.payoutsDashboard);
    switch(type){
        case 'payoutCreated':
            return {
                icon: /*#__PURE__*/ _jsx(Coins, {}),
                content: "A payout of ".concat(utils.formatDollarAmount(new Decimal(amount).div(100)), " was deposited to your bank account on ").concat(timeModel.formatDateWithTime(arrivalDate), "."),
                path: payoutPath,
                type
            };
    }
};
const getUserPresentationData = (userNotificationItem)=>{
    const { type, email, fullName } = userNotificationItem.user;
    const contactsPath = "".concat(routes.contacts, "?search=").concat(email);
    switch(type){
        case 'invalidEmail':
            return {
                icon: /*#__PURE__*/ _jsx(User, {}),
                content: fullName ? "Email to ".concat(fullName.first, " ").concat(fullName.last, " (").concat(email, ") bounced. Contact your client to update their email.") : "Email to ".concat(email, " bounced. Contact your client to update their email."),
                path: contactsPath,
                type
            };
    }
};
const getBusinessPresentationData = (businessNotificationItem)=>{
    const { type } = businessNotificationItem.business;
    switch(type){
        case 'kycVerificationNeeded':
            return {
                icon: /*#__PURE__*/ _jsx(Business, {}),
                content: 'KYC verification failed! Additional information is required in order to verify your business identity.',
                path: routes.home,
                type
            };
        case 'kycFutureVerificationNeeded':
            return {
                icon: /*#__PURE__*/ _jsx(Business, {}),
                content: 'Additional information is required in order to verify your business identity.',
                path: routes.home,
                type
            };
        case 'bankAccountMDVerificationStarted':
            {
                const { customerName } = businessNotificationItem.business.BankAccountMDVerificationStartedBusinessNotificationType;
                return {
                    icon: /*#__PURE__*/ _jsx(Bank, {}),
                    content: "".concat(customerName, " has started the micro-deposit verification process."),
                    type
                };
            }
    }
};
